import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'empty-state-view',
    templateUrl: './empty-state-view.component.html',
    styleUrls: ['./empty-state-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyStateViewComponent {
    @Output() public createProject = new EventEmitter<void>();
}
